import {UsuarioPesquisa, userAplicacao} from './../../model/usuario';
import {FiltroUsuarioAplicacao, FiltroAlteracaoEstado} from './../../model/filtros';
import {GlobalService} from './../../service/global.service';
import {FormControl} from '@angular/forms';
import {Component, OnInit, HostListener} from '@angular/core';
import {IMyDpOptions} from 'mydatepicker';
import {HttpClient} from '@angular/common/http';
import {JQueryStatic} from 'jquery';
import {Router} from '@angular/router';
import {MessageService} from 'primeng/api';


declare var $: JQueryStatic;
declare var $: any;


@Component({
    selector: 'app-usuario',
    templateUrl: './usuario.component.html',
    styleUrls: ['./usuario.component.css']
})
export class UsuarioComponent implements OnInit {

    constructor(
        public http: HttpClient,
        public globalService: GlobalService,
        private router: Router,
        private messageService: MessageService
    ) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13) {
                this.pesquisar();
            }
        }
    }

    ngOnInit() {
        setTimeout(() => {
            this.pesquisar();
        }, 500);
    }

    resultadoUsuario: any;

    nome = new FormControl('', []);
    descricao = new FormControl('', []);
    certificado = new FormControl('', []);
    matricula = new FormControl('', []);
    alarme_sia = new FormControl('', []);

    dtInicioConexao = new FormControl('', []);
    dtFimConexao = new FormControl('', []);

    uor = new FormControl('', []);
    mci = new FormControl('', []);


    pesquisado: boolean = false;

    hoje: Date = new Date();

    chaveComposta: any;

    cols: any[];
    selectedUser: UsuarioPesquisa;
    usuario: any;
    displayDialog: boolean;
    usuarioDelete: userAplicacao;

    paginaAtual: number = 1;
    pagina: number = 10;


    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        monthLabels: {
            1: 'Jan',
            2: 'Fev',
            3: 'Mar',
            4: 'Abr',
            5: 'Mai',
            6: 'Jun',
            7: 'Jul',
            8: 'Ago',
            9: 'Set',
            10: 'Out',
            11: 'Nov',
            12: 'Dez'
        },
        dayLabels: {su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
        sunHighlight: true,
        satHighlight: true,
        editableDateField: true,
        todayBtnTxt: 'Hoje',
        firstDayOfWeek: 'su',
        maxYear: this.hoje.getFullYear(),
        openSelectorOnInputClick: true
    };

    public editarUsuario(codUsuario, vrsUsuario) {
        this.router.navigate(['/usuario-novo', codUsuario, vrsUsuario]);
    }

    public novoUsuario(idUsuario) {
        this.router.navigate(['/usuario-novo']);
    }

    public removerUsuario(idUsuario) {
        this.router.navigate(['/usuario-novo']);
    }

    public pesquisar() {

        let usuarioPesquisa: UsuarioPesquisa = new UsuarioPesquisa();
        let filtroUsuarioAplicacao: FiltroUsuarioAplicacao = new FiltroUsuarioAplicacao();
        filtroUsuarioAplicacao.filtros = new Array<UsuarioPesquisa>();
        let filtroAlteracaoEstado: FiltroAlteracaoEstado = new FiltroAlteracaoEstado();


        if (this.nome.value != '') {
            usuarioPesquisa.username = this.nome.value;
        }

        if (this.descricao.value != '') {
            usuarioPesquisa.descricao = this.descricao.value;
        }

        if (this.certificado.value != '') {
            usuarioPesquisa.nomeCertificadoVinculado = this.certificado.value;
        }

        if (this.dtInicioConexao.value != '') {
            filtroUsuarioAplicacao.filtroAlteracaoEstado.dataInicial = this.dtInicioConexao.value;
        }

        if (this.dtFimConexao.value != '') {
            filtroUsuarioAplicacao.filtroAlteracaoEstado.dataFinal = this.dtFimConexao.value;
        }

        if (this.uor.value != '') {
            usuarioPesquisa.codUorVinc = this.uor.value;
        }

        if (this.mci.value != '') {
            usuarioPesquisa.codMciVinc = this.mci.value;
        }

        let objectSize = Object.keys(usuarioPesquisa).length;

        if (Object.keys(usuarioPesquisa).length > 0) {
            filtroUsuarioAplicacao.filtros.push(usuarioPesquisa);
        }

        filtroUsuarioAplicacao.filtroAlteracaoEstado = filtroAlteracaoEstado;

        let url = this.globalService.getConfiguracao().api_autorizador + '/usuario/filtra';
        // let data = JSON.stringify(filtroUsuarioAplicacao);

        let data = JSON.stringify(
            {
                'metadata': {'pagina': this.paginaAtual, 'porPagina': this.pagina},
                'filtros': filtroUsuarioAplicacao.filtros,
                'filtroAlteracaoEstado': filtroUsuarioAplicacao.filtroAlteracaoEstado

            });
        this.globalService.loading = true;

        this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise()
            .then(
                response => {
                    this.globalService.loading = false;
                    this.resultadoUsuario = response;
                    this.pesquisado = true;
                }
            ).catch(
            error => {
                this.globalService.loading = false;
                this.pesquisado = true;
                this.resultadoUsuario = [];
            }
        );
    }

    proximaPagina(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.paginaAtual++;
        this.pesquisar();
    }

    paginaAnterior(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.paginaAtual--;
        this.pesquisar();
    }


    public mudarPagina(pagina: number) {
        this.paginaAtual = pagina;
    }

    modalExcluirUsuario(codUsuario, vrsUsuario) {
        this.usuarioDelete = new userAplicacao();
        this.usuarioDelete.codUserAplicacao = codUsuario;
        this.usuarioDelete.versaoUserAplicacao = vrsUsuario;
        $('#modalUsuario').modal('show');

    }


    excluirUsuario() {

        let url = this.globalService.getConfiguracao().api_autorizador + '/usuario/excluir' + '/' + this.usuarioDelete.codUserAplicacao + '/' + this.usuarioDelete.versaoUserAplicacao;

        this.http.delete(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise()
            .then(
                () => {
                    this.pesquisar();
                    $('#modalUsuario').modal('hide');
                    this.avisoMensagem('Sucesso !', 1);
                }
            ).catch(
            () => {
                this.avisoMensagem('Erro ao excluir usuário !', 2);
                $('#modalUsuario').modal('hide');
            }
        );
    }

    mudarEstadoUsuario(codUsuario, vrsUsuario, operacao) {

        let url = this.globalService.getConfiguracao().api_autorizador + '/usuario/' + operacao + '/' + codUsuario + '/' + vrsUsuario;

        let data;

        this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise()
            .then(
                () => {
                    this.pesquisar();
                }
            ).catch(
            () => {
                this.avisoMensagem('Erro ao execultar operação !', 2);
            }
        );


    }

    // Messagem personalizadas
    avisoMensagem(msg: string, tipo: number) {
        if (tipo == 1) {
            this.messageService.add({severity: 'success', summary: '', detail: msg});
        } else {
            this.messageService.add({severity: 'error', summary: '', detail: msg});
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/usuario/usuario.component.ts